import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import {
  getEnumTranslationKey,
  normalizeNumericEnumValue,
  normalizeStringEnumValue,
} from '@/utils/core/data-transformation/enumHelpers';
import { getEnumNamespace } from '@/utils/infrastructure';
import { formatDynamicFieldsListForDetails } from '@/utils/infrastructure/dynamicFieldsListFormatter';
import { getIntl } from 'umi';
import formConfig from '../AccessPolicyForm/_form';

const { BaseFilters } = Filters;

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.updated',
  name: 'updated',
};

const ActiveFilter = {
  ...BaseFilters.BooleanFilter,
  name: 'isActive',
  label: 'accessPolicy.filters.active',
};

const EffectFilter = {
  ...BaseFilters.EnumFilter,
  name: 'effect',
  label: 'accessPolicy.filters.effect',
  enumNamespace: getEnumNamespace(CoreEnums.CompanyAccessPolicyEffect, 'AccessPolicy'),
  enumSource: CoreEnums.CompanyAccessPolicyEffect,
  options: createEnumOptions(CoreEnums.CompanyAccessPolicyEffect, 'accessPolicy.effect', {
    casing: 'camel',
  }),
};

export const filtersConfig = [UpdatedDateFilter, ActiveFilter, EffectFilter];

registerModuleFilters('accessPolicies', filtersConfig);

const RULE_FIELD = formConfig.fields.find((f) => f.name === 'definitionRules');

/** Detail rows for policy rules via formatDynamicFieldsListForDetails. */
export function buildAccessPolicyRuleDetailRows(definition, formatMessage) {
  if (!RULE_FIELD) {
    return [];
  }
  const rules = Array.isArray(definition?.rules) ? definition.rules : [];
  if (rules.length === 0) {
    return [];
  }

  const fm = formatMessage || ((opts) => getIntl().formatMessage(opts));
  const value = rules.map((row) => ({
    ...row,
    values: Array.isArray(row?.values) ? row.values.join(', ') : row?.values ?? '',
  }));

  return formatDynamicFieldsListForDetails({
    key: 'definitionRules',
    value,
    fieldConfig: RULE_FIELD,
    labelKey: 'accessPolicy.definition.rules',
    specialHandlers: {
      enumHandler: (fieldName, raw) => {
        if (fieldName === 'ruleType') {
          const rt = normalizeNumericEnumValue(
            CoreEnums.CompanyAccessPolicyRuleType,
            raw?.value ?? raw,
            CoreEnums.CompanyAccessPolicyRuleType.ScopeRole,
          );
          const k = getEnumTranslationKey(
            CoreEnums.CompanyAccessPolicyRuleType,
            rt,
            'accessPolicy.ruleType',
          );
          return fm({ id: k });
        }
        if (fieldName === 'operator') {
          const op = normalizeStringEnumValue(
            CoreEnums.ComparisonOperator,
            raw?.value ?? raw,
            CoreEnums.ComparisonOperator.Equal,
          );
          const k = getEnumTranslationKey(
            CoreEnums.ComparisonOperator,
            op,
            'accessPolicy.operator',
          );
          return fm({ id: k });
        }
        return String(raw ?? '');
      },
    },
  });
}
